import { useQuery } from '@rocicorp/zero/react'
import { formatCents, formatTime } from '../../lib/format.ts'
import {
  paymentMethodLabel,
  paymentReferenceDetails,
  paymentStatus,
} from '../../lib/payments.ts'
import { queries } from '../../zero/queries.ts'
import { PagedSection, usePagedLimit } from './PagedSection.tsx'

/** Every payment, including pending and cancelled ones. */
export function PaymentHistory({ userId }: { userId: string }) {
  const { limit, showMore } = usePagedLimit()
  const [payments, result] = useQuery(queries.paymentHistoryForUser({ userId, limit }))

  return (
    <PagedSection
      title="Payments"
      shown={payments.length}
      limit={limit}
      showMore={showMore}
      complete={result.type === 'complete'}
      emptyText="No payments recorded."
    >
      {payments.map((payment) => {
        const status = paymentStatus(payment)
        const reference = paymentReferenceDetails(payment.importTransaction?.rawData)
        return (
          <div className="line" key={payment.paymentId}>
            <div className="line-main">
              <div className="line-title">
                {paymentMethodLabel(payment.paymentMethod)}
                <span className={`pill-tag pill-tag--${status.toLowerCase()}`}>{status}</span>
              </div>
              <div className="line-sub">{formatTime(payment.createdAt)}</div>
              {reference ? (
                <div className="line-sub payment-reference">
                  <strong>Ref:</strong> {reference}
                </div>
              ) : null}
            </div>
            <span className="line-amount">{formatCents(payment.amountCents)}</span>
          </div>
        )
      })}
    </PagedSection>
  )
}
